import React from 'react';
import moment from 'moment';

import DatePickerInput from 'components/form/DatePickerInput.component';

import BackButton from 'booking/components/common/bw-header/BackButton';
import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import BWFooter from 'booking/components/common/BWFooter';
import PageTitle from 'booking/components/common/PageTitle';

import CN from './RepeatBooking.module.scss';

class RepeatBooking extends React.Component {
  // noinspection JSDeprecatedSymbols
  UNSAFE_componentWillMount() {
    this.props.changeRepeat();
  }

  onChangeDate = (date) => void this.props.changeRepeatUntil(date);
  handleSubmit = () => void this.props.history.goBack();

  render() {
    const isEditing = this.props.isEditBooking;
    let appointmentDate;
    if (this.props.addedServices.length > 0) {
      appointmentDate = moment(this.props.addedServices[0].start_time);
    } else {
      appointmentDate = moment();
    }
    return (
      <div data-bem="RepeatBooking" className="BookingWindow header-center">
        <HeaderWrapper>
          <BackButton
            onClick={() => {
              this.props.changeRepeat(); // not click on 'Save changes' so toggle repeat booking back
              this.props.history.goBack();
            }}
          />
          <PageTitle pageTitle="Repeat Booking" subTitle="" />
        </HeaderWrapper>
        <BWContent additionalClass="repeat-booking">
          <div>
            <div className={CN.flex}>
              <div className={CN.weeksContainer}>
                Every
                <select
                  value={this.props.frequency}
                  onChange={(ev) => void this.props.changeRepeatFrequency(ev.target.value)}
                  disabled={isEditing}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>

                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                </select>
                Weeks until
              </div>
              <div className={CN.pickerContainer}>
                <DatePickerInput
                  tag="RepeatBooking__until"
                  component={DatePickerInput.ReactDatePickerOld}
                  className="repeat_booking_datepicker"
                  dateFormat="YYYY-MM-DD"
                  selected={this.props.until}
                  locale="en-GB"
                  style={{ width: '115px' }}
                  onChange={(date) => void this.props.changeRepeatUntil(date)}
                  minDate={appointmentDate}
                />
              </div>
            </div>
            <div>
              <p className="repeat-info">BOOKINGS WILL REPEAT FOR 1 YEAR BY DEFAULT</p>
              <p className="repeat-info2">
                To change this, click the date above and select your preferred end date for the series
              </p>
            </div>
          </div>
        </BWContent>
        <BWFooter additionalClass="transparent">
          <button
            className="btn btn-violet pull-right repeat-booking"
            style={{ width: 150 }}
            onClick={() => {
              this.handleSubmit();
            }}
          >
            Save Changes
          </button>
        </BWFooter>
      </div>
    );
  }
}

export default RepeatBooking;
